import topic from '../topic'
export const ppinAPI = {
    getPpins: topic.ppinTopic + '/get_ppins',
    // getPpinById: topic.ppinTopic + '/get_ppin_by_id',
    // addPpin: topic.ppinTopic + '/add_ppin',
    // editPpin: topic.ppinTopic + '/edit_ppin',
    destroyPpinByIds: topic.ppinTopic + '/destroy_ppin_by_ids'
}